import { Component, createRef } from 'preact';
import { html } from '../../helpers/preact-html';
import { MobileNavigationSelector } from './MobileNavigationSelector.component';
import { MobileNavigationPageL1 } from './MobileNavigationPageL1.component';
import { MobileNavigationPage } from './MobileNavigationPage.component';
import { MobileNavigationHeader } from './MobileNavigationHeader.component';
import { MobileNavigationFooter } from './MobileNavigationFooter.component';

class MobileNavigation extends Component {
  constructor() {
    super();
    this.refContentarea = createRef();

    this.state = {
      currentMenuLayer: 1,
      currentFirstLayerMenuItemId: null,
      currentSubmenuItemId: null,
      currentThirdLayerMenuItemId: null,
    };
    this.onSelectSubmenu = this.onSelectSubmenu.bind(this);
    this.onNavigateBack = this.onNavigateBack.bind(this);
  }

  componentWillMount() {
    const { navTree } = this.props;
    this.setState({ currentFirstLayerMenuItemId: navTree.items[0].id });
  }

  onCurrentFirstLayerMenuItemChange(newMenuItem) {
    this.scrollToTop();
    this.setState({
      currentFirstLayerMenuItemId: newMenuItem,
      currentMenuLayer: 1,
    });
  }

  onSelectSubmenu(submenuId) {
    this.scrollToTop();
    const { currentMenuLayer } = this.state;
    switch (currentMenuLayer) {
      case 1:
        this.setState({
          currentMenuLayer: this.state.currentMenuLayer + 1,
          currentSubmenuItemId: submenuId,
        });
        break;
      case 2:
        this.setState({
          currentMenuLayer: this.state.currentMenuLayer + 1,
          currentThirdLayerMenuItemId: submenuId,
        });
        break;
      default:
        break;
    }
  }

  onNavigateBack() {
    const { currentMenuLayer } = this.state;
    if (currentMenuLayer > 1) {
      this.scrollToTop();
      this.setState({
        currentMenuLayer: currentMenuLayer - 1,
      });
    }
  }

  scrollToTop() {
    this.refContentarea.current.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }

  renderNavigationPage() {
    const {
      currentFirstLayerMenuItemId,
      currentSubmenuItemId,
      currentThirdLayerMenuItemId,
      currentMenuLayer,
    } = this.state;
    const { navTree } = this.props;

    const firstLayerMenu = navTree.items.find(
      ({ id }) => currentFirstLayerMenuItemId === id,
    );

    switch (currentMenuLayer) {
      case 1:
        return html`
          <${MobileNavigationHeader} navTree=${navTree} />
          <${MobileNavigationPageL1}
            key=${currentFirstLayerMenuItemId}
            navPage=${firstLayerMenu}
            onSelectSubmenu=${this.onSelectSubmenu}
          />
        `;
      case 2:
        const submenu = firstLayerMenu.children.find(
          ({ id }) => currentSubmenuItemId === id,
        );

        return html`
          <${MobileNavigationPage}
            key=${currentSubmenuItemId}
            navPage=${submenu}
            onNavigateBack=${this.onNavigateBack}
            onSelectSubmenu=${this.onSelectSubmenu}
          />
        `;
      case 3:
        const submenuParent = firstLayerMenu.children.find(
          ({ id }) => currentSubmenuItemId === id,
        );
        const thirdLayerMenu = submenuParent.children.find(
          ({ id }) => currentThirdLayerMenuItemId === id,
        );
        return html`
          <${MobileNavigationPage}
            key=${currentThirdLayerMenuItemId}
            navPage=${thirdLayerMenu}
            onNavigateBack=${this.onNavigateBack}
            onSelectSubmenu=${this.onSelectSubmenu}
          />
        `;
      default:
        break;
    }
  }

  render(
    { navTree, logo, onCloseButtonClick },
    { currentFirstLayerMenuItemId },
  ) {
    return html`
      <a href="/" class="navigation-logo">
        <img
          src=${logo.src}
          alt=${logo.alt}
          width=${logo.width}
          height=${logo.height}
        />
      </a>
      <button
        onClick=${onCloseButtonClick && onCloseButtonClick}
        type="button"
        class="button navigation-closebutton button-icon button-tertiary button-icon-largeicon"
        aria-label="Menü Schließen"
        data-trigger="nav"
      >
        <i class="ri-close-line" aria-label="Schließen Symbol"></i>
      </button>

      <${MobileNavigationSelector}
        navTree=${navTree}
        currentSlideId=${currentFirstLayerMenuItemId}
        onSlideIdChange=${this.onCurrentFirstLayerMenuItemChange.bind(this)}
      />
      <div class="navigation-contentarea" ref=${this.refContentarea}>
        ${this.renderNavigationPage()}
        <${MobileNavigationFooter} navTree=${navTree} />
      </div>
    `;
  }
}

export { MobileNavigation };
